import { Scope } from "./types";

type ScopeRoutesOptions = {
    onlyAllowedRoutes: boolean;
};

export const getScopeRoutesOptions = (scope: Scope = null): ScopeRoutesOptions => {
    switch (scope) {
        case Scope.SignPackages:
            return { onlyAllowedRoutes: true };
        case Scope.Tariffication:
            return { onlyAllowedRoutes: true };
        case Scope.DataVerificationCompany:
            return { onlyAllowedRoutes: true };
        case Scope.InvoicePreview:
            return { onlyAllowedRoutes: true };
        case Scope.Preview:
            return { onlyAllowedRoutes: false };
        case Scope.SchoolClaim:
            return { onlyAllowedRoutes: false };
        case Scope.Color:
            return { onlyAllowedRoutes: false };
        default:
            return { onlyAllowedRoutes: false };
    }
};
